import PropTypes from 'prop-types';
import { UnderlinedButton } from 'jl-design-system/elements/button/Button';

import styles from './DetailAction.scss';

export const DetailAction = ({ text = 'Edit', onClick, extraClassName = '' }) => (
  <UnderlinedButton
    onClick={onClick}
    className={`${styles.DetailAction} ${styles[extraClassName]}`}
  >
    {text}
  </UnderlinedButton>
);

DetailAction.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  extraClassName: PropTypes.string,
};
